import { PaymentSourceCaptureErrorResponse } from '../model'

export const isPaymentsSourceCaptureApiError = (e: any): e is PaymentSourceCaptureErrorResponse => typeof e?.error?.code === 'string'
